import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
import CryptoJS from "crypto-js";
export default {
  props: {
    typeof: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    var _this = this;

    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== _this.passwordForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      show1: true,
      show2: false,
      show3: false,
      count: 60,
      loginBg: require("assets/images/wlx-login-bg.png"),
      btnName: "login",
      passwordForm: {
        phoneNum: "",
        password: "",
        surePassword: "",
        verfyCode: ""
      },
      changePass: "password",
      passwordRules: {
        role: [{
          required: true,
          message: "请选择身份",
          trigger: "change"
        }],
        phoneNum: [{
          required: true,
          message: "请输入手机号",
          trigger: "blur"
        }],
        verfyCode: [{
          required: true,
          message: "请输入验证码",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }],
        surePassword: [{
          validator: validatePass2,
          trigger: "blur"
        }]
      }
    };
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.state.auth;
    },
    association: function association() {
      return this.$store.state.association;
    },
    target: function target() {
      var Urlname = "";

      if (this.$store.state.auth.userType === 1) {
        Urlname = "stuBasicInfo";
      } else if (this.$store.state.auth.userType === 2) {
        Urlname = "teaApply";
      } else if (this.$store.state.auth.userType === 3) {
        Urlname = "siteBasicInfo";
      } else if (this.$store.state.auth.userType === 9) {
        Urlname = "systemManager";
      }

      return {
        name: Urlname
      };
    }
  },
  created: function created() {
    this.$store.dispatch(MU_UPATE_SCHOOL, {
      id: window.location.href
    });
  },
  watch: {
    association: {
      handler: function handler(val) {},
      deep: true
    }
  },
  methods: {
    backToHome: function backToHome() {
      if (this.typeof == "jdtestExam") {
        window.location.href = "http://jdmock.chinahoteledu.com/login";
      } else if (this.typeof == "fdtestExam") {
        window.location.href = "http://fdmock.chinahoteledu.com/login";
      } else if (this.typeof == "train") {
        window.location.href = "http://tea.chinahoteledu.com/login";
      } else if (this.typeof == "") {
        this.$router.push({
          name: "xIndex"
        });
      }
    },
    complete: function complete(formName) {
      var _this2 = this;

      var that = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          that.RetrievePwd();
        } else {
          _this2.$message({
            message: "请输入信息",
            type: "error"
          });

          return false;
        }
      });
    },
    // 发送验证码
    sendMessage: function sendMessage() {
      var _this3 = this;

      var once = true;
      var str_ = Date.parse(new Date()) / 1000;
      var str = this.encryption(str_);
      var str1 = CryptoJS.MD5(str_ + "").toString();
      var s1 = str1.substring(0, 7);
      var s2 = str1.substring(7);
      console.log(this.passwordForm.phoneNum);
      str1 = s1 + "s" + s2;

      if (once) {
        var that = this;
        this.$http.post("/api/XOrg/XLogin/sendCode", {
          verifyInfo: that.passwordForm.phoneNum,
          str: str,
          str1: str1
        }).then(function (rst) {
          if (rst.code > 0) {
            _this3.$message.success(rst.msg);

            _this3.verifyCode = rst.verifyCode;
            var TIME_COUNT = 60;

            if (!_this3.timer) {
              _this3.count = TIME_COUNT;
              _this3.show1 = false;
              _this3.show2 = true;
              _this3.show3 = false;
              _this3.timer = setInterval(function () {
                if (_this3.count > 0 && _this3.count <= TIME_COUNT) {
                  _this3.count--;
                  once = false;
                } else {
                  _this3.show1 = false;
                  _this3.show2 = false;
                  _this3.show3 = true;
                  clearInterval(_this3.timer);
                  _this3.timer = null;
                  once = true;
                }
              }, 1000);
            }
          } else {
            _this3.$message.warning(rst.msg);
          }
        });
      }
    },
    encryption: function encryption(str) {
      var Base64 = require("js-base64").Base64;

      return Base64.encode(str);
    },
    // 登录后跳转
    roleEnter: function roleEnter() {
      // if (this.$store.state.auth.userType === 1) {
      //     this.$router.push({
      //         name: "stuBasicInfo",
      //     });
      // } else if (this.$store.state.auth.userType === 2) {
      //     this.$router.push({
      //         name: "teaApply",
      //     });
      // } else if (this.$store.state.auth.userType === 3) {
      //     this.$router.push({
      //         name: "siteBasicInfo",
      //     });
      // } else if (this.$store.state.auth.userType === 9) {
      //     this.$router.push({
      //         name: "systemManager",
      //     });
      // }
      this.$router.push({
        name: "xIndex"
      });
    },
    //重置密码
    RetrievePwd: function RetrievePwd() {
      var that = this;
      this.$http.post("/api/XOrg/XLogin/RetrievePwd", {
        moblie: that.passwordForm.phoneNum,
        shortMessage: that.passwordForm.verfyCode,
        passWord: that.passwordForm.password,
        associationId: that.association.Id
      }).then(function (rst) {
        if (rst.code > 0) {
          that.$message({
            message: rst.msg,
            type: 'success'
          });
          that.originTypeOf();
        } else {
          that.$message({
            message: rst.msg,
            type: "warning"
          });
        }
      });
    },
    // 从哪来回哪去
    originTypeOf: function originTypeOf() {
      var _this4 = this;

      if (this.typeof == "jdtestExam") {
        window.location.href = "http://jdmock.chinahoteledu.com/login";
      } else if (this.typeof == "fdtestExam") {
        window.location.href = "http://fdmock.chinahoteledu.com/login";
      } else if (this.typeof == "train") {
        window.location.href = "http://tea.chinahoteledu.com/login";
      } else if (this.typeof == "") {
        this.$store.dispatch(MU_UPATE_AUTH).then(function () {
          _this4.roleEnter();
        });
      }
    }
  }
};